export default {
  greeting: "hi,{name}",
  components: {
    head1: {
      title: {
        login: "登录",
        register: "注册",
        forget: "忘记密码",
      },
      intro1: "工业用品数字化",
      intro2: "采购服务平台",
      right1: "返回登录",
      right2: "已有账号？",
      right3: "请登录",
    },
    head2: {
      welcome_to_roke: "欢迎来到洛克",
      login_prompt: "请登录",
      free_register: "免费注册",
      welcome: "欢迎",
      welcome_name: "欢迎，{name}",
      logout: "退出",
      message: "消息",
      latest_messages: "最新消息",
      no_messages: "暂无消息",
      view_all: "查看全部",
      my_orders: "我的订单",
      all_orders: "全部订单",
      pending_payment: "待付款",
      pending_shipment: "待发货",
      pending_receipt: "待收货",
      completed: "已完成",
      aftersale: "我的售后",
      personal_center: "个人中心",
      order_center: "订单中心",
      invoice: "发票",
      invoice_info: "开票信息",
      apply_invoice: "发票申请",
      my_invoice: "我的发票",
      records: "记录",
      browse_history: "浏览历史",
      my_collection: "我的收藏",
      product_review: "商品评价",
      settings: "设置",
      my_info: "我的信息",
      company_info: "企业信息",
      addresses: "地址管理",
      usage_guide: "使用指南",
      guide_how_to_order: "如何下单",
      guide_view_order_progress: "查看订单进度",
      guide_shipping_fee: "运费政策",
      guide_after_sale_policy: "售后政策",
      guide_how_to_apply_invoice: "如何申请发票",
      guide_contact_us: "联系我们",
      platform_intro: "工业用品数字化<br />采购服务平台",
      search_placeholder: "请输入产品名称",
      search: "搜索",
      shopping_cart: "我的购物车",
      cate_name: "全部商品",
      language: "Language",
      lang_zh: "中文",
      lang_en: "English",
    },
    foot1: {
      text1: "苏公网安备 31000000000000号",
      text2:
        "Copyright© zkh.com 1998-2024 Corporation All Rights Reserved 苏ICP备10008888号南通洛克流体设备有限公司",
    },
    foot2: {
      perk1: {
        title: "正品货源",
        text: "正品保障 诚信服务",
      },
      perk2: {
        title: "货期保障",
        text: "自有工厂 货期无忧",
      },
      perk3: {
        title: "专属客服",
        text: "选型询价 快速响应",
      },
      perk4: {
        title: "专属价格",
        text: "厂家批发 价格更优",
      },
      shoppingGuide: "购物指南",
      guideUsage: "使用指南",
      payMethods: "付款方式",
      payInvoiceInfo: "付款开票信息",
      howToPay: "如何支付",
      servicePolicy: "服务政策",
      userAgreement: "用户协议",
      privacyPolicy: "隐私政策",
      saleService: "售后服务",
      contentCenter: "内容中心",
      latestInfo: "最新信息",
      importantNotice: "重要通知",
      sampleDownload: "样册下载",
      personalCenter: "个人中心",
      orderManage: "订单管理",
      invoiceManage: "开票管理",
      aboutUs: "关于我们",
      platformIntro: "公司简介",
      contactUs: "联系我们",
      platformTagline: "数字化工业用品服务平台",
      workTime: "工作时间：周一到周五8:30~17:30",
      customerWechat: "客服微信",
      publicSecurity: "苏公网安备 31000000000000号",
      copyright:
        "Copyright© zkh.com 1998-2024 Corporation All Rights Reserved 苏ICP备10008888号南通洛克流体设备有限公司",
    },
    addressPopup: {
      title: "新增收货地址",
      labelName: "姓名:",
      placeholderName: "长度不超过20个字符",
      labelPhone: "电话:",
      placeholderPhone: "请输入电话号码",
      labelAddress: "地址:",
      selectProvince: "请选择省份",
      selectCity: "请选择城市",
      selectArea: "区/县/街道",
      labelDetailAddress: "详细地址:",
      placeholderDetailAddress: "请填写详细地址",
      labelZipcode: "邮政编码:",
      placeholderZipcode: "如果不清楚请填000000",
      labelIsDefault: "是否为默认:",
      textDefaultAddress: "默认收货地址",
      btnSave: "保存",
      btnCancel: "取消",
    },
    calendar: {
      week1: "一",
      week2: "二",
      week3: "三",
      week4: "四",
      week5: "五",
      week6: "六",
      week7: "日",
    },
    pagination: {
      next: "下一页>>",
    },
    popupInvoice: {
      title: "发票信息",
      invoice_type: "发票类型:",
      char_special: "专",
      type_special: "数电专票",
      char_general: "普",
      type_general: "数电普票",
      invoice_head: "发票抬头:",
      invoice_taxno: "纳税人识别号:",
      invoice_register_address: "注册地址:",
      invoice_register_mobile: "注册电话:",
      invoice_branch: "开户银行:",
      invoice_accountno: "银行账号:",
      btnSave: "保存",
      btnCancel: "取消",
    },
    index: {
      prompt_title: "洛克流体2024年印度尼西亚海事展",
      prompt_link: "详情请点击",
      banner_all_categories: "全部商品分类",
      welcome_hello: "您好，欢迎",
      welcome_line2: "到洛克工业品商城！",
      login: "登录",
      enjoy_discount: "享优惠",
      register_btn: "免费注册",
      welcome_banner: "欢迎您来到洛克工业品商城!",
      hello_prefix: "您好!",
      account_security: "账号安全:中",
      change_password: "修改密码",
      more_details: "更多详情",
      recommended_products: "推荐商品",
      latest_info: "最新信息",
      important_notice: "重要通知",
      view_all: "查看全部 >",
      fixed_login: "登录",
      fixed_cart: "购物车",
      fixed_collection: "收藏",
      fixed_guide: "指南",
      fixed_customer_service: "客服",
      fixed_back: "返回",
      btn_my_orders: "我的订单",
      btn_my_collection: "我的收藏",
      btn_invoice_manage: "开票管理",
      btn_usage_guide: "使用指南",
    },
    my: {
      leftTitle: "个人中心",
      orderCenter: "订单中心",
      order_my: "我的订单",
      aftersale: "我的售后",
      invoice: "发票",
      invoice_info: "开票信息",
      apply_invoice: "发票申请",
      my_invoice: "我的发票",
      history: "历史",
      browse_history: "商品浏览记录",
      collection: "收藏夹",
      my_collection: "我的收藏",
      message: "消息",
      messages_overview: "消息一览",
      comment: "评价",
      uncomment: "待评价商品",
      commented: "已评价商品",
      settings: "设置",
      my_info: "我的信息",
      company_info: "企业信息",
      addresses: "地址管理",
    },
  },
  pages: {
    login: {
      validation: {
        phone_required: "手机号不能为空",
        password_required: "登录密码不能为空",
        code_required: "验证码不能为空"
      },
      tab1: "手机验证码登录",
      tab2: "账号登录",
      phoneNumber: "手机号",
      phonePlaceholder: "请输入手机号",
      password: "密码",
      passwordPlaceholder: "请输入密码",
      verifyCode: "验证码",
      codePlaceholder: "请输入验证码",
      getCode: "获取验证码",
      reGetCCode: "{time}秒后重新发送",
      loginBtn: "登录",
      register: "免费注册",
      forgetPwd: "忘记密码？",
    },
    register: {
      title1: "欢迎您注册",
      title2: " 洛克 ",
      title3: "工业品商城！",
      phoneLabel: "手机号",
      phonePlaceholder: "请输入手机号",
      verifyCodeLabel: "验证码",
      codePlaceholder: "请输入验证码",
      getCode: "获取验证码",
      reGetCCode: "{time} 秒后重新发送",
      countryLabel: "国别",
      enterpriseLabel: "企业名称",
      enterprisePlaceholder: "请输入企业名称",
      contactLabel: "联系人姓名",
      contactPlaceholder: "请输入联系人姓名",
      emailLabel: "邮箱地址",
      emailPlaceholder: "请输入邮箱地址",
      submitBtn: "注册",
      agree1: "我已阅读并同意 ",
      agree2: "《洛克商城用户协议》",
      agree3: "《洛克隐私政策》",
      please_accept: "请先阅读并勾选协议",
      register_success: "注册成功",
      register_fail: "注册失败",
      pageTitle: "账号注册",
    },
    pay: {
      tab_online: "在线支付",
      tab_done: "完成",
      order_submitted_msg:
        "订单已提交成功，请您及时付款，我们将尽快为您安排发货!",
      order_no: "订单编号:",
      order_amount: "订单金额:",
      countdown1: "(请在",
      countdown2: "{hours}小时",
      countdown3: "{minutes}分钟",
      countdown4: "{seconds}秒",
      countdown5: "内完成付款,否则订单将自动取消!)",
      paid_success: "您的订单已付款成功，请耐心等待发货！",
      open_alipay: "打开手机支付宝",
      scan_to_pay: "扫一扫继续付款",
      ive_paid_view_order: "我已支付，去查看订单",
      open_wechat: "打开手机微信",
      proceed_to_pay: "去支付",
    },
    info: {
      breadcrumb: "首页  > 最新消息 > 查看更多",
      breadcrumb2: "首页  > 重要通知 > 查看更多",
      published: "发布时间：",
      views: "{count}人看了",
      hot_recommend: "热门推荐",
      previous: "上一篇",
      next: "下一篇>",
    },
    appraisal: {
      breadcrumb: "首页  >   个人中心   >   评价   >   已评价商品",
      title: "评价详情",
      platform_order_no: "平台订单号：",
      order_time: "下单时间：",
      evaluation_time: "评价时间",
      product_score: "商品评分",
      evaluation_content: "评价晒单",
      share_images: "分享图片",
      score_format: "{score}分",
    },
    category: {
      sort_title_template: "首页 > {name}分类 > {name}分类商品列表",
      all_list: "全部分类",
      all_products_category: "全部商品分类",
      path_three: "{first} > {second} > {third}",
      path_two: "{first} > {second}",
      path_one: "{first}",
    },
    car: {
      breadcrumb: "首页  >   购物车",
      cart_title: "购物车",
      search_placeholder: "输入关键词搜索购物车内商品",
      search_btn: "搜索",
      th_select: "全选",
      th_item_info: "商品信息",
      th_spec_param: "规格/参数",
      th_unit_price: "单价",
      th_quantity: "数量",
      th_subtotal: "小计",
      th_actions: "操作",
      incl_tax: "(含税)",
      excl_tax: "(未税)",
      collect: "收藏",
      delete: "删除",
      select_all: "全选",
      delete_selected: "删除选中商品",
      total_summary: "已选：{count} 件 应含税总额：￥{amount}",
      pay_btn: "去结算",
      confirm_delete_message: "确认从购物车删除该产品吗?",
      confirm_title: "提示",
      confirm_confirm: "确认",
      confirm_cancel: "取消",
      select_products_warning: "请选择产品！",
    },
    comment: {
      breadcrumb: "首页  >   个人中心   >   评价   >   待评价商品",
      title: "评价详情",
      platform_order_no: "平台订单号：",
      order_time: "下单时间：",
      product_score: "商品评分",
      evaluation_content: "评价晒单",
      share_images: "分享图片",
      textarea_placeholder: "分享使用心得，给万千想买的人一个有价值的参考~",
      delete: "删除",
      tip_text: "共<span>{count}</span>张，还能上传<span>{max}</span>张",
      submit_btn: "发表评价",
      anonymous_label: "匿名评价",
      image_type_error: "图片类型不正确！",
      image_size_error: "图片大小不能超过5MB！",
      image_max_error: "最多允许上传{max}张图片！",
    },
    confirmOrder: {
      breadcrumb: "首页  >   购物车 > 订单确认",
      steps: {
        pick: "选购",
        submit: "提交订单",
        done: "完成",
      },
      address_title: "收货地址",
      add_address_btn: "+新增收货地址",
      no_address: "暂无收货地址，请{add}",
      add: "添加",
      default: "默认",
      edit: "编辑",
      delete: "删除",
      set_default: "设为默认收货地址",
      more_addresses: "更多收货地址({count})",
      invoice_title: "发票信息",
      invoice_type_special: "数电专票",
      invoice_type_general: "数电普票",
      add_invoice: "+添加发票信息",
      invoice_head: "发票抬头：",
      invoice_taxno: "纳税人识别号：",
      invoice_register_address: "注册地址：",
      invoice_register_mobile: "注册电话：",
      invoice_branch: "开户银行：",
      invoice_accountno: "银行账号：",
      pay_method_title: "支付方式",
      online_pay: "在线支付",
      pay_support: "支持",
      pay1: "微信",
      pay2: "支付宝",
      pay3: "在线支付",
      product_list_title: "商品清单",
      back_to_cart: "返回购物车修改 >>",
      th_item_info: "商品信息",
      th_spec_param: "规格/参数",
      th_unit_price: "单价",
      th_quantity: "数量",
      th_subtotal: "小计",
      remarks_title: "采购备注",
      delivery_date_label: "期望交货日期：",
      delivery_option_all: "工作日及周末均接受送货",
      delivery_option_weekday: "仅工作日接受送货",
      purchase_order_no_label: "采购订单号：",
      purchase_order_placeholder: "请填写贵公司标准采购订单编号",
      memo_label: "备注：",
      memo_placeholder: "请填写采购备注信息，建议跟客服事先确认",
      attachments_label: "附件：",
      update_tip:
        "（支持jpeg、jpg、png等图片格式，最多上传{max}个，每个大小小于{size}）",
      total_count: "商品总数：",
      total_amount_label: "商品含税总额：",
      total_tax_label: "税额：",
      freight_label: "运费：",
      total_pay_label: "应付含税总额：",
      submit_btn: "提交订单",
      confirm_delete_receive: "确认删除该收货信息吗?",
      confirm_set_default: "确认将此收货地址设为默认吗?",
      confirm_title: "提示",
      confirm_confirm: "确认",
      confirm_cancel: "取消",
      image_type_error: "图片类型不正确！",
      image_size_error: "图片大小不能超过5MB！",
      image_max_error: "最多允许上传{max}张图片！",
      submitting: "下单中...",
    },
    detail: {
      home: "首页",
      collect: "收藏商品",
      collected: "已收藏",
      model_label: "型号：",
      material_label: "材质：",
      size_label: "尺寸：",
      eva_count: "{count}条评价",
      description: "描述：",
      spec_label: "规格：",
      rechoose: "重新选择",
      price_unit:"￥",
      unit_price_label: "单价 (未税)：",
      total_price_excl: "总价 (未税)：",
      total_price_incl: "总价 (含税)：",
      expected_ship_label: "预计发货日：",
      days_text: "{num}天",
      logistics_price: "起送价：满300元起送",
      product_catalog: "产品样册:",
      download_btn: "点击下载",
      pay_method_label: "支付方式：",
      wechat: "微信",
      alipay: "支付宝",
      online_pay: "在线支付",
      add_to_cart: "加入购物车",
      buy_now: "立即购买",
      wholesale_note:
        "批发采购：如您需要大批量批发采购，请联系{online_service}",
      online_service: "在线客服",
      more_products: "更多商品",
      table_title: "型号规格",
      operation: "操作",
      choose: "选择",
      chosen: "已选",
      product_details: "商品详情",
      product_reviews: "商品评价({count})",
      rating_label: "评分：{score}分",
      select_model_first: "请先选择型号",
    },
    download: {
      sort_title: "首页  >   样册下载",
      all_list: "全部分类",
      page_title: "样册下载",
      search_placeholder: "请输入关键字",
      search_btn: "搜索",
      download_btn: "下载",
    },
    forget: {
      tab_verify: "身份验证",
      tab_reset: "密码重置",
      tab_done: "完成",
      label_mobile: "手机号",
      placeholder_mobile: "请输入手机号",
      label_code: "验证码",
      placeholder_code: "请输入验证码",
      get_code: "获取验证码",
      re_send_seconds: "{count} 秒后重新发送",
      next: "下一步",
      label_newpwd: "新密码",
      placeholder_newpwd: "请输入新密码",
      label_confirmpwd: "确认密码",
      placeholder_confirmpwd: "请再次输入新密码",
      confirm: "确定",
      success_text: "密码修改成功",
      auto_redirect: "{count}s后自动跳转至登录页",
      go_login: "前往登录",
      msg_enter_mobile: "请输入手机号码",
      msg_enter_code: "请输入验证码",
      msg_newpwd_required: "新密码必填",
      msg_confirmpwd_required: "确认密码必填",
      msg_reset_success: "重置密码成功",
    },
    guide: {
      left_title: "使用指南",
      menu: {
        personal_center: "个人中心",
        new_user_guide: "新手指南",
        delivery_policy: "配送政策",
        after_sales: "售后服务",
        faq: "常见问题",
        about_us: "关于我们",
        register: "如何注册",
        agreement: "用户协议",
        privacy_policy: "隐私政策",
        forget: "忘记密码",
        to_buy: "如何下单",
        to_pay: "如何支付",
        to_search_order: "查看订单进度",
        shipping_fee: "运费政策",
        shipping_instructions: "发货交期说明",
        sale_policy: "售后政策",
        invoice_apply: "如何申请发票",
        invoice_search: "如何查看发票",
        platform: "平台介绍",
        contact: "联系我们",
      },
      register_title: "如何注册",
      register_content:
        "洛克商城注册指南：欢迎加入洛克工业品数字化商城，按提示填写手机号、企业信息并完成验证即可注册。",
      agreement_title: "用户协议",
      agreement_content:
        "《洛克商城用户协议》：请阅读并遵守用户注册、服务使用、信息发布等条款。",
      privacy_policy_title: "隐私政策",
      privacy_policy_content:
        "《洛克隐私政策》：说明我们如何收集、使用、存储和保护您的个人信息。",
      forget_title: "忘记密码",
      forget_content:
        "密码找回指南：通过手机号和验证码验证身份，设置新密码完成重置。",
      to_buy_title: "如何下单",
      to_buy_content:
        "下单流程指南：登录→查找商品→加入购物车→提交订单→选择支付并完成支付。",
      to_pay_title: "如何支付",
      to_pay_content:
        "支付方式指南：支持微信、支付宝、银联等多种支付方式，注意支付凭证保存。",
      to_search_order_title: "查看订单进度",
      to_search_order_content:
        "订单进度查询指南：在个人中心查看订单列表并跟踪物流状态。",
      shipping_fee_title: "运费政策",
      shipping_fee_content:
        "运费政策：具体计费规则以商品详情页及最终支付金额为准，退换货运费按原因区分。",
      shipping_instructions_title: "发货交期说明",
      shipping_instructions_content:
        "发货交期说明：现货与定制商品发货时效不同，工作日15:00为分界。",
      sale_policy_title: "售后政策",
      sale_policy_content: "售后政策：退换货、退款及售后服务流程与要求说明。",
      invoice_apply_title: "如何申请发票",
      invoice_apply_content:
        "发票申请指南：在个人中心找到发票申请并按提示操作，企业用户请填写纳税人识别号。",
      invoice_search_title: "如何查看发票",
      invoice_search_content:
        "发票查看指南：在个人中心的我的发票中查看并下载电子发票。",
      platform_title: "平台介绍",
      platform_content:
        "平台介绍：洛克工业品数字化商城，提供液压配件一站式采购与供应链服务。",
      contact_title: "联系我们",
      contact_content:
        "联系我们：客服电话 86-513-85400443，邮箱 admin@ntroke.com，工作时间 8:30-17:30。",
    },
  },
  mypages: {
    addresses: {
      title: "地址管理",
      createdPrefix: "您已创建",
      createdSuffix: "个地址",
      add: "新增地址",
      th_recipient: "收件人",
      th_phone: "电话",
      th_address: "地址",
      th_action: "操作",
      default_label: "默认",
      edit: "修改",
      delete: "删除",
      confirm_delete: "确认删除该收货信息吗?",
      confirm_title: "提示",
      confirm_confirm: "确认",
      confirm_cancel: "取消",
    },
    afterSale: {
      title: "我的售后",
      label_platform_order_no: "平台订单号:",
      placeholder_platform_order_no: "请输入平台订单号",
      label_product_name: "商品名称:",
      placeholder_product_name: "请输入商品名称",
      label_service_no: "售后单号:",
      placeholder_service_no: "请输入采购订单号",
      label_apply_time: "申请售后时间:",
      search: "查询",
      reset: "重置",
      th_service_no: "售后单号",
      th_platform_order_no: "平台订单号",
      th_product_name: "商品名称",
      th_spec: "规格型号",
      th_buy_quantity: "购买数量",
      th_after_quantity: "售后数量",
      th_action_status: "操作/状态",
      refunded: "已退款",
      exchanged: "已换货",
    },
    applyInvoice: {
      title: "我的订单",
      tab_pending: "待开票",
      tab_applying: "申请中",
      label_platform_order_no: "平台订单号:",
      placeholder_platform_order_no: "请输入平台订单号",
      label_purchase_order_no: "采购订单号:",
      placeholder_purchase_order_no: "请输入采购订单号",
      label_order_time: "下单时间:",
      search: "查询",
      reset: "重置",
      th_platform_order_no: "平台订单编号",
      th_order_time: "下单时间",
      th_purchase_order_no: "采购订单编号",
      th_buyer: "订购人",
      th_order_amount: "订单金额 (含税)",
      th_action: "操作",
      btn_apply_invoice: "申请发票",
    },
    collections: {
      title: "我的收藏",
      th_image: "产品图片",
      th_brand_name: "品牌/名称",
      th_description: "产品描述",
      th_price: "价格",
      th_fav_time: "收藏时间",
      th_action: "操作",
      add_to_cart: "加入购物车",
      delete: "删除",
      confirm_delete: "确认从收藏中删除该产品吗?",
      confirm_title: "提示",
      confirm_confirm: "确认",
      confirm_cancel: "取消",
    },
    comments: {
      title: "我的评价",
      tab_to_comment: "待评价商品",
      tab_commented: "已评价商品",
      th_order_detail: "订单详情",
      th_quantity: "数量",
      th_amount: "金额",
      th_recipient: "收货人",
      th_action: "操作",
      platform_order_no: "平台订单号：",
      purchase_order_no: "采购订单号：",
      order_time: "下单时间：",
      btn_review_now: "立即评价",
      btn_order_detail: "订单详情",
      text_commented: "已评价",
      btn_view_review: "查看评价",
    },
    history: {
      title: "浏览历史",
      th_image: "产品图片",
      th_brand_name: "品牌/名称",
      th_description: "产品描述",
      th_price: "价格",
      th_view_time: "浏览时间",
      th_action: "操作",
      add_to_cart: "加入购物车",
      delete: "删除",
      confirm_delete_msg: "确认从浏览记录中删除该产品吗?",
      confirm_title: "提示",
      confirm_ok: "确认",
      confirm_cancel: "取消",
    },
    invoiceInfo: {
      title: "开票信息",
      label_invoice_type: "发票类型：",
      tab_short_special: "专",
      tab_special: "数电专票",
      tab_short_general: "普",
      tab_general: "数电普票",
      invoice_head: "发票抬头：",
      invoice_taxno: "发票税号：",
      invoice_branch: "开户银行：",
      invoice_accountno: "银行账号：",
      invoice_register_address: "注册地址：",
      invoice_register_mobile: "注册电话：",
      edit: "编辑",
    },
    invoices: {
      title: "我的发票",
      label_invoice_no: "发票号码:",
      placeholder_invoice_no: "请输入发票号码",
      label_platform_order_no: "平台订单号:",
      placeholder_platform_order_no: "请输入平台订单号",
      label_purchase_order_no: "采购订单号:",
      placeholder_purchase_order_no: "请输入采购订单号",
      label_invoice_time: "开票时间:",
      search: "查询",
      reset: "重置",
      th_invoice_no: "发票编号",
      th_invoice_time: "开票时间",
      th_invoice_amount: "发票金额 (含税)",
      th_platform_order_no: "平台订单编号",
      th_purchase_order_no: "采购订单编号",
      th_action: "操作",
      btn_download: "下载发票",
    },
    messages: {
      title: "消息一览",
      mark_all_read: "全部已读",
      tab_1_month: "近1个月内的消息",
      tab_3_months: "3个月内的消息",
      tab_1_year: "1年内的消息",
      tab_3_years: "3年内的消息",
    },
    myInfo: {
      title: "我的信息",
      section_personal: "个人信息",
      username_label: "用户名：",
      nickname_label: "姓 名：",
      email_label: "邮 箱：",
      gender_label: "性 别：",
      gender_male: "男",
      gender_female: "女",
      edit: "编辑",
      save: "保存",
      cancel: "取消",
      section_security: "账户安全",
      login_password_label: "登录密码：",
      modify: "修改",
      password_change_advice: "建议定期更改密码以保护帐户安全",
      bind_phone_label: "绑定手机：",
      phone_lost_advice: "若手机丢失或停用，请及时更换",
      account_security_title: "账号与安全",
      set_password: "设置密码",
      label_verify_code: "验证码：",
      placeholder_enter_code: "输入验证码",
      get_code: "获取验证码",
      reSendSeconds: "{count} 秒后重新发送",
      label_password: "密 码：",
      placeholder_enter_password: "输入密码",
      label_confirm_password: "确认密码：",
      placeholder_confirm_password: "请再次输入密码",
      modify_phone_title: "修改手机号码",
      step_verify_sms: "短信验证",
      step_change_phone: "更换新手机号",
      step_done: "完成",
      bind_phone_label: "绑定手机号码：",
      label_sms_code: "短信验证码：",
      placeholder_enter_smscode: "请输入验证码",
      verify_next: "验证进入下一步",
      label_new_phone: "新手机号码：",
      placeholder_new_phone: "请输入新手机号码",
      submit: "提交",
      bind_account: "绑定手机号码：",
      validation: {
        checkcode_required: "验证码必填",
        newpassword_required: "新密码必填",
        confirmpwd_required: "确认密码必填",
      },
      password_change_success: "修改密码成功",
      password_change_failed: "修改密码失败",
      enter_old_smscode: "请输入原手机的短信验证码",
      enter_newphone: "请输入新手机号码",
      enter_newsmscode: "请输入新手机验证码",
      phone_update_success: "手机修改成功",
      placeholder_captcha: "请输入右侧计算结果",
      change_image: "换张图",
      enter_captcha: "请输入验证码",
    },
    order: {
      title: "我的订单",
      tab_all: "全部订单",
      tab_pending_payment: "待付款",
      tab_pending_ship: "待发货",
      tab_pending_receive: "待收货",
      tab_completed: "已完成",
      label_platform_order_no: "平台订单号:",
      placeholder_platform_order_no: "请输入平台订单号",
      label_product_name: "商品名称:",
      placeholder_product_name: "请输入商品名称",
      label_purchase_order_no: "采购订单号:",
      placeholder_purchase_order_no: "请输入采购订单号",
      label_order_time: "下单时间:",
      search: "查询",
      reset: "重置",
      header_order_info: "订单信息",
      header_spec: "规格型号",
      header_quantity: "数量",
      header_total_amount: "总金额",
      header_status: "订单状态",
      header_action: "操作",
      platform_order_no: "平台订单号：",
      purchase_order_no: "采购订单号：",
      order_time: "下单时间：",
      recipient: "收件人：",
      invoice_title: "发票抬头：",
      status_pending_payment: "待支付",
      status_pending_ship: "待发货",
      status_pending_receive: "待收货",
      status_received: "已收货",
      status_cancelled: "已取消",
      view_detail: "查看详情",
      pay_now: "立即支付",
      cancel_order: "取消订单",
      add_to_cart: "加入购物车",
      confirm_receive: "确认收货",
    },
    orderDetail: {
      title: "订单详情",
      platform_order_no: "平台订单号：",
      pay_method: "支付方式：",
      pay_online: "在线支付",
      order_status: "订单状态：",
      section_receive_info: "收货信息",
      label_recipient: "收件人：",
      label_recipient_phone: "联系电话：",
      label_recipient_address: "收货地址：",
      section_invoice_info: "发票信息",
      label_invoice_type: "发票类型：",
      label_invoice_head: "发票抬头：",
      label_tax_no: "发票税号：",
      section_remark: "备注信息",
      label_expect_delivery: "期望交货日期：",
      delivery_all_days: "工作日及周末均接受送货",
      delivery_workday_only: "仅工作日接受送货",
      label_purchase_order_no: "采购订单号：",
      label_order_memo: "采购备注：",
      memo_none: "无",
      label_attachments: "附件",
      th_product_info: "商品信息",
      th_spec: "规格型号",
      th_lead_time: "参考交期",
      th_quantity: "数量",
      th_subtotal_incl_tax: "含税小计",
      th_status: "状态",
      lead_time_contact: "交期详询客服",
      settlement_total_count: "商品总数：",
      settlement_total_amount: "商品含税总额：",
      settlement_tax: "税额：",
      settlement_shipping: "运费：",
      settlement_payable: "应付含税总额：",
      btn_pay_now: "立即支付",
    },
    compayInfo: {
      title: "企业信息",
      enterprise_label: "企业名称：",
      contact_name_label: "联系人姓名：",
      contact_mobile_label: "联系电话：",
      email_label: "邮箱地址：",
      address_label: "详细地址：",
      placeholder_province: "请选择省份",
      placeholder_city: "请选择城市",
      placeholder_area: "区/县/街道",
      placeholder_address: "请填写办公详细地址",
      edit: "编辑",
      save: "保存",
      cancel: "取消",
    },
  },
  common: {
    switch: "切换语言",
  },
};
